export const priceOptions = [{
    value: '',
    label: 'Select...',
}, {
    value: '0 - 100000',
    label: 'IDR 0 - 100.000'
}, {
    value: '100000 - 250000',
    label: 'IDR 100.000 - 250.000'
}, {
    value: '250000 - 500000',
    label: 'IDR 250.000 - 500.000'
}, {
    value: '500000 - 1000000',
    label: 'IDR 500.000 - 1.000.000'
}, {
    value: '1000000 - 2500000',
    label: 'IDR 1.000.000 - 2.500.000'
}, {
    value: '1000000 - 2500000',
    label: 'IDR 1.000.000 - 2.500.000'
}, {
    value: '2500000 - 5000000',
    label: 'IDR 2.500.000 - 5.000.000'
}, {
    value: '5000000 - 10000000',
    label: 'IDR 5.000.000 - 10.000.000'
}, {
    value: '10000000 - xxx',
    label: '> IDR 10.000.000'
}]

export const statusOptions = [
    {
        value: '',
        label: 'Select...',
    },
    {
        value: 'confirmed',
        label: 'Confirmed',
    },
    {
        value: 'processed',
        label: 'Processed',
    },
    {
        value: 'cancelled',
        label: 'Cancelled',
    }
]